import React, { useCallback } from 'react';

import PropTypes from 'prop-types';

import { WeightInput } from 'ui-components/components/weight-input';

import { UnitDisplayType, UnitDisplayTypePropType } from '../../../enums/units/unit-display-type';
import { UnitPosition, UnitPositionPropType } from '../../../enums/units/unit-position';
import { usePackagesWeightInSellerUnit } from '../../../hooks/use-packages-weight-in-seller-unit';
import { convertFromWeightUnitEnum, convertToWeightUnitEnum } from '../../../services/unit-services/weights/weight-unit-enum-converter';
import { useFulfillmentPlannerContext } from '../../context';

const FulfillmentPlannerWeightInput = ({
  className = null,
  inputClassName = null,
  shrinkable = false,
  unitDisplayType = UnitDisplayType.AbbreviatedWithParentheses,
  unitPosition = UnitPosition.OutsideEnd,
  weightInputInnerContainerClassName,
  numberInputContainerClassName,
  labelId,
}) => {
  const { onWeightAndDimensionsChange, packages = [], setHasSmartFillDataBeenChanged } = useFulfillmentPlannerContext();
  const weight = usePackagesWeightInSellerUnit(packages);

  const onChange = useCallback(
    (formWeight, weightInputUnit) => {
      const newWeight = {
        unit: convertToWeightUnitEnum(weightInputUnit),
        value: formWeight,
      };
      if (newWeight.value !== weight?.value) {
        onWeightAndDimensionsChange(newWeight);
        setHasSmartFillDataBeenChanged((prevState) => ({
          ...prevState,
          weight: true,
        }));
      }
    },
    [onWeightAndDimensionsChange, weight, setHasSmartFillDataBeenChanged],
  );

  return (
    <WeightInput
      className={className}
      disabled={packages.length > 1}
      inputClassName={inputClassName}
      labelId={labelId}
      numberInputContainerClassName={numberInputContainerClassName}
      onChange={onChange}
      shrinkable={shrinkable}
      unit={convertFromWeightUnitEnum(weight.unit)}
      unitDisplayType={unitDisplayType}
      unitPosition={unitPosition}
      weight={weight.value}
      weightInputInnerContainerClassName={weightInputInnerContainerClassName}
    />
  );
};

FulfillmentPlannerWeightInput.propTypes = {
  className: PropTypes.string,
  inputClassName: PropTypes.string,
  shrinkable: PropTypes.bool,
  numberInputContainerClassName: PropTypes.string,
  weightInputInnerContainerClassName: PropTypes.string,
  unitDisplayType: UnitDisplayTypePropType,
  unitPosition: UnitPositionPropType,
  labelId: PropTypes.string,
};

export default FulfillmentPlannerWeightInput;
